export const API_ENDPOINTS = {
    INDEX_CONFIG: '/s_api/basic/index_config',
    CONFIG_V2: '/api/basic/config_v2_js',
    TOKEN_RATES: '/api/quote/v1/rates',
    FUNDING_RATES: '/api/contract/funding_rates',
    USER_BASE_INFO: '/api/user/get_base_info',
    ORDER_POSITIONS: '/api/contract/order/position',
    FUTURE_OPEN_ORDERS: '/api/contract/order/open_orders',
    FUTURE_TRADE_ORDERS: '/api/contract/order/trade_orders',
    FUTURE_MY_TRADES: '/api/contract/order/my_trades',
    LOGOUT: '/api/user/authorize_cancel',
    CREATE_FUTURE_ORDER: '/api/contract/order/create',
    AVAILABLE_FUTURE_ASSETS: '/api/contract/asset/available',
    CALCULATE_PROFIT_INFO: '/api/contract/calculator/profit_info',
    CALCULATE_LIQUIDATION_PRICE: '/api/contract/calculator/liquidation_price',
    GET_FUTURE_ORDER_SETTING: '/api/contract/order/get_order_setting',
    SET_FUTURE_ORDER_SETTING: '/api/contract/order/set_order_setting',
    FUTURE_POSITIONS: '/api/contract/order/position',
    CREATE_FAVORITE: '/api/user/favorite/create',
    CANCEL_FAVORITE: '/api/user/favorite/cancel',
    CANCEL_ORDER: '/api/contract/order/cancel',
    WALLETS_SUB_ACCOUNTS: '/api/account/sub_account/query',
    TRANSFER_BALANCE: '/api/account/sub_account/transfer',
    TRANSFER_AVAILABLE: '/api/account/sub_account/transfer/available',
    MARGIN_TRANSFER_AVAILABLE: '/api/v1/margin/get/avail_withdraw',
    WALLET_COIN_TOKENS: '/api/basic/coin_tokens',
    KLINE_HISTORY: '/api/quote/v1/klines',
    INDEX_KLINE_HISTORY: '/api/quote/v1/index/klines',
    SERVER_TIME: '/api/quote/v1/time',
    SET_RISK_LIMIT: `/api/contract/order/set_risk_limit`,
    GET_POSITION_STOP_PROFIT_LOSS: '/api/contract/order/position/stop_profit_loss/get',
    SET_POSITION_STOP_PROFIT_LOSS: '/api/contract/order/position/stop_profit_loss/set',
    CANCEL_POSITION_STOP_PROFIT_LOSS: '/api/contract/order/position/stop_profit_loss/cancel',
    MODIFY_POSITION_MARGIN: '/api/contract/asset/modify_margin',
    TOKEN_INFO: '/s_api/basic/token',
    AVAILABLE_SPOT_ASSETS: '/api/asset/get',
    SPOT_ACTIVE_OPEN_ORDERS: '/api/order/open_orders',
    SPOT_CONDITIONAL_OPEN_ORDERS: '/api/order/plan_spot/open_orders',
    SPOT_ACTIVE_TRADE_ORDERS: '/api/order/trade_orders',
    SPOT_CONDITIONAL_TRADE_ORDERS: '/api/order/plan_spot/trade_orders',
    SPOT_MY_TRADES: '/api/order/my_trades',
    SPOT_ACTIVE_ORDER_CANCEL: '/api/order/cancel',
    SPOT_CONDITIONAL_ORDER_CANCEL: '/api/order/plan_spot/cancel',
    GET_SPOT_CONDITIONAL_ORDER: '/api/order/plan_spot/get',
    GET_SPOT_LIMIT_MARKET_ORDER: '/api/order/match_info',
    GET_SPOT_ORDER_SETTING: '/api/order/get_order_setting',
    SET_SPOT_ORDER_SETTING: '/api/order/set_order_setting',
    CREATE_SPOT_ORDER: '/api/order/create',
    CREATE_SPOT_CONDITIONAL_ORDER: '/api/order/plan_spot/create',
    USER_ASSETS_INFO: '/api/asset/info',
    CANCEL_ALL_SPOT_LIMIT_ORDERS: '/api/order/batch_cancel',
    CANCEL_ALL_SPOT_CONDITIONAL_ORDERS: '/api/order/plan_spot/batch_cancel',
    REFRESH_AUTH_TOKEN: '/api/user/auth_token/refresh',
    SET_LEVERAGE: '/api/contract/asset/modify_leverage',
    GET_LEVERAGE: '/api/contract/asset/leverage',
    GET_USER_VERIFY_INFO: '/api/user/verify_info',
    GET_USER_INVITE_CODE: '/api/invitation/info/get',
    GET_USER_LEVEL_INFO: '/api/user/get_userlevel_info',
    GET_SETTINGS: '/api/user/get_settings',
    SET_SETTINGS: '/api/user/set_settings',
    GET_NOTIFICATIONS: '/api/notifications/list',
    GET_POPUP_NOTIFICATIONS: 'api/notifications/popup/list',
    MARK_NOTIFICATION_AS_READ: 'api/notifications/mark_read',
    OPEN_FUTURES: 'api/user/open/futures',
    GET_USER_FEATURES_CONFIG: '/api/user/features_config',
    GET_USER_KYC_CONFIG: '/api/user/kyc_config',
    GET_USER_BONUS: '/loyalty/api/bonuses/user-bonuses',
};
